<template>
  <b-button
    @click="trigger"
    size="sm"
    variant="light"
    block
    >
    {{locale === 'zh' ? '中' : 'EN'}}
  </b-button>
</template>

<script>
import common from '@/mixins/common.js'

export default {
  name: "LangSwitch",
  mixins: [common],
  components: {
    
  },
  props: {
    
  },
  data: function() {
    return {
      
    }
  },
  methods: {
    trigger() {
      this.$i18n.set(this.oppLocale);
      this.$nextTick(() => {
        localStorage.setItem("lang", this.locale);
      })
    },
    init() {
      var lang = localStorage.getItem("lang");
      if (typeof lang !== 'undefined' && lang !== null) {
        this.$i18n.set(lang);
      }
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style>
</style>
